var exports = {
  "Xy": "ColumnWorkflowIndicator__APVzbf",
  "pd": "ColumnWorkflowIndicatorDisabled___MJVQD",
  "_U": "WorkflowStateDot__V0p0C4",
  "UB": "WorkflowStateDotDisabled__TMZfte",
  "ki": "ColumnWorkflowStatusLabel__P5-wjt",
  "gk": "ColumnWorkflowStatusLabelDisabled__gHY6b_",
  "WP": "GroupHeading__6-xXLQ",
  "qp": "GroupHeadingRow__7kehQN",
  "Zk": "WorkflowStatusPill__tc_4Yu",
  "$K": "WorkflowStatusPillActive__p4EEvX",
  "jK": "WorkflowStatusPillPaused__pMEu2x",
};

module.exports = exports;
